/* ------------------------------------------------------------------
 *  検索に関する関数
--------------------------------------------------------------------- */

// form送信時に空のクエリを送信しないようにする関数
(function ($) {
  function cleanQuery(query) {
    const arr = [];
    $.each(query.split("&"), (i, param) => {
      if (param.split("=")[1]) {
        arr.push(param);
      }
    });
    return arr.join("&");
  }

  $.fn.cleanQuery = function () {
    this.on("submit", function (event) {
      event.preventDefault();

      const query = cleanQuery($(this).serialize());
      const spacer = this.action.indexOf("?") != -1 ? "&" : "?";
      location.href = `${this.action}${spacer}${query}`;
    });

    return this;
  };
})(jQuery);

function cleanQueryFromQuery(query) {
  query = decodeURI(query);
  const arr = [];
  $.each(query.split("&"), (i, param) => {
    if (param.split("=")[1]) {
      arr.push(param);
    }
  });
  const newFullPath = arr.join("&");
  const path = query.includes("?") ? query.split("?")[0] : "";
  return newFullPath.includes(path) ? newFullPath : `${path}?${newFullPath}`;
}

/* ------------------------------------------------------------------
検索結果件数取得関数
--------------------------------------------------------------------- */
function get_search_number(
  id = "jsDetailSearch",
  result_selector = ".jsResultNum",
  count_params = "&only_count=1"
) {
  const form = $(`form#${id}`);
  const url = form.data("api-path");
  let param = form.serialize();
  param = cleanQueryFromQuery(param);
  param += count_params;
  $.ajax({
    url,
    type: "GET",
    dataType: "script",
    data: param,
    success(data) {
      $(result_selector).text(data);
    },
    error(_XMLHttpRequest, _textStatus, _errorThrown) {
      console.log("error");
    },
  });
}

/* ------------------------------------------------------------------
リクエストパラメータの取得
--------------------------------------------------------------------- */
(function ($) {
  $.extend({
    getParameter: function getParameter() {
      const arg = {};
      const pair = location.search.substring(1).split("&");
      for (let i = 0; pair[i]; i += 1) {
        const kv = pair[i].split("=");
        arg[kv[0]] = kv[1];
      }
      return arg;
    },
  });
})(jQuery);

/* ------------------------------------------------------------------
検索ボタンのリンク化
--------------------------------------------------------------------- */
function setReplaceSearchButton() {
  function replaceSearchButton(form) {
    function getQuickSearchParams() {
      const params = {};
      let conditions = ["area_keywords", "area", "genre", "posi"];
      if (form.data("vol-or-job") === "job") {
        params.job = "job";
        conditions = ["area", "wf", "genre"];
      }
      conditions.forEach((condition) => {
        const name =
          condition === "area_keywords"
            ? form.find(`input`).attr("value")
            : form.find(`select#${condition}_ option:selected`).attr("name");
        if (name) params[condition] = name;
      });
      return params;
    }

    function generateSeoPath() {
      const keys = (Object.keys(params) || []).filter((k) => k !== "job");
      if (params.area_keywords || keys.length > 2) {
        return "";
      }
      if (keys.length === 0) {
        return [params.job, "all"].filter((e) => e).join("/");
      }
      const seoPath = [
        params.job,
        params.wf,
        params.area,
        params.genre,
        params.posi,
      ]
        .filter((e) => e)
        .join("/");
      if (
        keys.length === 2 &&
        params.posi &&
        !form.data("existing-path-for-quick-search").includes(`/${seoPath}`)
      ) {
        return "";
      }
      return seoPath;
    }

    // オンライン、海外、都道府県選択時は、ページキャッシュを利用
    function convertToArea(areaKeywords) {
      if (areaKeywords) {
        const area =
          areaKeywords != "京都"
            ? areaKeywords.replace(/都$|府$|県$/, "")
            : areaKeywords;
        const areaHash = {
          オンライン: "online",
          海外: "abroadarea",
          北海道: "hokkaido",
          青森: "aomori",
          岩手: "iwate",
          宮城: "miyagi",
          秋田: "akita",
          山形: "yamagata",
          福島: "fukushima",
          茨城: "ibaraki",
          栃木: "tochigi",
          群馬: "gunma",
          埼玉: "saitama",
          千葉: "chiba",
          東京: "tokyo",
          神奈川: "kanagawa",
          新潟: "nigata",
          富山: "toyama",
          石川: "ishikawa",
          福井: "fukui",
          山梨: "yamanashi",
          長野: "nagano",
          岐阜: "gifu",
          静岡: "shizuoka",
          愛知: "aichi",
          三重: "mie",
          和歌山: "wakayama",
          滋賀: "shiga",
          京都: "kyoto",
          大阪: "osaka",
          兵庫: "hyogo",
          奈良: "nara",
          徳島: "tokushima",
          香川: "kagawa",
          愛媛: "ehime",
          高知: "kochi",
          山口: "yamaguchi",
          鳥取: "tottori",
          島根: "shimane",
          岡山: "okayama",
          広島: "hiroshima",
          福岡: "fukuoka",
          佐賀: "saga",
          長崎: "nagasaki",
          熊本: "kumamoto",
          大分: "oita",
          宮崎: "miyazaki",
          鹿児島: "kagoshima",
          沖縄: "okinawa",
        };
        if (areaHash[area]) {
          params.area = areaHash[area];
          delete params.area_keywords;
        }
      }
    }

    const params = getQuickSearchParams();
    convertToArea(params.area_keywords);
    const seoPath = generateSeoPath();
    const searchBtn = form.find(`button, a`);
    const searchText = searchBtn[0].innerHTML;
    const newSearchBtn =
      seoPath.length > 0
        ? `<a href="/${seoPath}" class="${searchBtn.attr(
            "class"
          )}">${searchText}</a>`
        : `<button type="submit" class="${searchBtn.attr(
            "class"
          )}">${searchText}</button>`;
    searchBtn.replaceWith(newSearchBtn);
  }

  $("form.jsReplaceSearchBtnHeader").each(function () {
    replaceSearchButton($(this));
  });
  $("form.jsReplaceSearchBtnHeader").change(function () {
    replaceSearchButton($(this));
  });
}

// NOTE: React ESM バンドルからアクセスできるよう window に公開する
// AreaSearchText.jsx 等のコンポーネントからグローバル関数として呼び出される
window.setReplaceSearchButton = setReplaceSearchButton;
window.get_search_number = get_search_number;
// NOTE: esbuild はモジュールレベルの副作用がない純粋な関数宣言をバンドルから除外する
// Sprockets からの移行のため、グローバルアクセスを維持するために window に公開する

/* ------------------------------------------------------------------
「もっと読む」の表示
--------------------------------------------------------------------- */
function readMore() {
  $("#js2LinesLimit").trunk8({
    lines: 2,
    fill: '&hellip; <a id="jsReadMore" class="searchResultMoreTag" href="#">全て表示</a>',
  });
  $("#jsReadMore").click(() => {
    $("#js2LinesLimit").trunk8({
      lines: 100,
    });
  });

  $(".js2LinesLimitBottom").each(function () {
    const count = 17;
    const thisText = $(this).text();
    const textLength = thisText.length;
    if (textLength > count) {
      const showText = thisText.substring(0, count);
      const hideText = thisText.substring(count, textLength);
      let insertText = showText;
      insertText += `<span class="hide">${hideText}</span>`;
      insertText += '<span class="omit">… </span>';
      insertText +=
        '<a class="jsReadMoreBottom p_descLink more" href="#"><i class="fa fa-caret-down" aria-hidden="true"></i>続きを表示</a>';
      $(this).html(insertText);
    }
  });
  $(".js2LinesLimitBottom .hide").hide();
  $(".js2LinesLimitBottom .more").click(function () {
    $(this)
      .hide()
      .prev(".omit")
      .hide()
      .prev(".hide")
      .fadeIn()
      .css({ opacity: "1" });
    return false;
  });

  $(".jsReadMoreBottom").click(function (e) {
    $(this).parent("p").trunk8({
      lines: 100,
    });
    e.preventDefault();
  });
}

export {
  setReplaceSearchButton,
  get_search_number,
  cleanQueryFromQuery,
  readMore,
};
